import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router';
import * as routes from '../constants/routes';
import { Link, Redirect } from 'react-router-dom';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import CssBaseline from '@material-ui/core/CssBaseline';
import axios from 'axios';
import * as db from '../db/db';
import moment from 'moment'
import * as statuses from '../constants/requestStatus';
import { AppContext } from "../context/applicationContext";
const baseUrl = (process.env.PUBLIC_URL==='/'?'': process.env.PUBLIC_URL) ||'';

const env = process.env.NODE_ENV;

let counter = 0;
function createData(id, title, status, employee, dateFrom, dateTo, TypeOfRequest) {
    counter += 1;
    return { 'id': id, 'title': title, 'status': status, 'employee': employee, 'dateFrom': dateFrom, 'dateTo': dateTo, 'typeOfRequest': TypeOfRequest };
}
class HolidaysTable extends React.Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            rows: this.props.list,
            page: 0,
            rowsPerPage: 10,
            userSite: null,
            userId: null,
            redirectToEdit: false,
            holidayId: null,
            siteUrl: null,
            progress: true,
            viewRequest: true,
            redirectToAddNew: false,
            redirectToHolidaysList: false,
            redirectToHolidaysConsentList: false,
            approveListDisabled: false,
            syncProgress: true,
        };
    }

    componentDidMount() {
        if (this.context.userId !== null && this.context.userId !== undefined) {
            this.setState({ userId: this.context.userId });

        } else {
            this.logOut();
        }
    }

    logOut = () => {
        this.context.setStateCustom('userId', null);
        db.idbMethods.clear(db.userInfo);
        db.idbMethods.clear(db.holidaysForApprove);
        db.idbMethods.clear(db.holidaysForApproveList);
        db.idbMethods.clear(db.myHolidays);
        this.setState({ redirect: true });
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
        window.scrollTo(0, 0);
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
        window.scrollTo(0, 0);
    };

    handleUserData = (e) => {
        this.setState({ userData: e });
    }

    openHolidayForEdit = (id, siteUrl) => {
        this.setState({ redirectToEdit: true });
        this.setState({ holidayId: id });
        this.setState({ siteUrl: siteUrl });

    }

    formatTime = (time) => {
        return moment(time).format('DD.MM.YYYY');;
    }

    addNewrequest = () => {
        this.setState({ redirectToAddNew: true });
    }

    getUserData(id, siteUrl) {
        const link = 'api/getUserData';

        axios.post(link, {
        }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                if (res.status === 200) {
                    this.setState({ fullName: res.data.FullName, employe: res.data, progress: false });

                    db.idbMethods.getAll(db.userInfo).then((userInfo) => {
                        if (userInfo !== undefined || userInfo !== null || userInfo.length !== 0) {
                            var user = userInfo[0];
                            user.Days = res.data.Days;
                            user.Department = res.data.Department;
                            user.UserPosition = res.data.UserPosition;
                            this.handleUserData(user);
                            db.idbMethods.set(user, db.userInfo);
                        }
                    })
                }
            }).catch(error => {
                console.log(error);
                var errorObj = error;
                this.props.enqueueSnackbar(errorObj.response.data.errorMsg, { variant: "error" });
                this.logOut();
            })
    }

    setRowStyle = (requestType) => {
        switch (requestType) {
           case statuses.CANCELED://ЧЕРВЕН СТАТУС
                return 'reject-request';
           case statuses.APPROVE://ЗЕЛЕН СТАТУС
                return 'approve-request';
           case statuses.REJECTED://СИВ СТАТУС
                return 'canceled-request';
           case statuses.FOR_CONFIRM://ЖЪЛТ СТАТУС
                return 'confirm-first-level';
           case statuses.FOR_CONFIRM_REJECT:
                return 'confirm-first-level';
            default:
                return 'confirm-first-level';
        }

    }

    setNoHolidayRowStyle = (requestType) => {
        switch (requestType) {
           case statuses.CANCELED://ЧЕРВЕН СТАТУС
                return 'reject-request';
           case statuses.APPROVE://ЗЕЛЕН СТАТУС
                return 'approve-request';
           case statuses.REJECTED://СИВ СТАТУС
                return 'canceled-request';
           case statuses.FOR_CONFIRM://ЖЪЛТ СТАТУС
                return 'confirm-first-level';
           case statuses.FOR_CONFIRM_REJECT:
                return 'confirm-first-level';
            default:
                return 'confirm-first-level';
        }

    }

    tableLabel = (from, to, count) => {
        return `${from}-${to} от ${count}`;
    }

    render() {
        const { rowsPerPage, page } = this.state;
        const rows = this.props.list;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

        if (this.state.redirect) {
            return <Redirect to={routes.HOME_LOGIN} />
        }

        if (this.state.redirectToEdit) {
            if (this.context.redirectFrom == 'myHolidays') {
                return <Redirect to={baseUrl +'/holidayView/' + this.state.holidayId} />
            } else {
                return <Redirect to={baseUrl +'/holiday/' + this.state.siteUrl + '/' + this.state.holidayId} />
            }
        }

        return (
            <React.Fragment>
                <CssBaseline />
                <div className='tableWrapper'>
                    <Table className='table table-custom'>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Служител</TableCell>
                                <TableCell align="left">Начална дата</TableCell>
                                <TableCell align="left">Крайна дата</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => (
                                <TableRow key={row.id} onClick={() => this.openHolidayForEdit(row.id,row.siteUrl)} className={row.typeOfRequest == 'Болничен' ? this.setNoHolidayRowStyle(row.status) : this.setRowStyle(row.status)}>
                                    <TableCell align="left">{row.employee}</TableCell>
                                    <TableCell align="left">{row.dateFrom}</TableCell>
                                    <TableCell align="left">{row.dateTo}</TableCell>
                                </TableRow>
                            ))}
                            {/* {emptyRows > 0 && (
                                <TableRow style={{ height: 48 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )} */}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    colSpan={3}
                                    count={rows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    labelDisplayedRows={({ from, to, count }) => {
                                        return `${from}-${to} от ${count}`
                                    }}
                                    labelRowsPerPage='Резултати'
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </React.Fragment>

        )
    }
}

export default withRouter((HolidaysTable));
